/* Collection controls use Shopify's full result set. Default availability refreshes only the catalog. */
(function (window, document) {
  'use strict';
  function decode(value) {
    try { return decodeURIComponent(value.replace(/\+/g, ' ')); } catch (error) { return value; }
  }
  function parse(search) {
    return String(search || '').replace(/^\?/, '').split('&').filter(Boolean).map(function (pair) {
      var split = pair.indexOf('=');
      return split < 0 ? [decode(pair), ''] : [decode(pair.slice(0, split)), decode(pair.slice(split + 1))];
    });
  }
  function query(pairs) {
    return pairs.map(function (pair) { return encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]); }).join('&');
  }
  function formDestination(path, currentSearch, names, entries, defaultAvailable) {
    var pairs = parse(currentSearch).filter(function (pair) {
      return pair[0] !== 'page' && names.indexOf(pair[0]) === -1;
    });
    entries.forEach(function (pair) {
      if (pair[0] && String(pair[1]).trim() !== '' && pair[0] !== 'page') { pairs.push([pair[0], String(pair[1])]); }
    });
    if (defaultAvailable && names.indexOf('filter.v.availability') !== -1) {
      pairs = availabilityIntent(pairs);
    }
    var search = query(pairs);
    return path + (search ? '?' + search : '');
  }
  // Explicitly choosing all statuses must survive sorting, tags, and pagination.
  function availabilityIntent(pairs) {
    pairs = pairs.filter(function (pair) { return pair[0] !== 'wo_availability'; });
    if (!pairs.some(function (pair) { return pair[0] === 'filter.v.availability' && pair[1] !== ''; })) {
      pairs.push(['wo_availability', 'all']);
    }
    return pairs;
  }
  function defaultDestination(path, search, enabled) {
    if (!enabled) { return ''; }
    var pairs = parse(search);
    if (pairs.some(function (pair) {
      return (pair[0] === 'filter.v.availability' && pair[1] !== '') || (pair[0] === 'wo_availability' && pair[1] === 'all');
    })) { return ''; }
    pairs = pairs.filter(function (pair) { return pair[0] !== 'page' && pair[0] !== 'filter.v.availability' && pair[0] !== 'wo_availability'; });
    pairs.push(['filter.v.availability', '1']);
    return path + '?' + query(pairs);
  }
  function contextSearch(targetSearch, currentSearch, preserveFilters) {
    var target = parse(targetSearch);
    var names = target.map(function (pair) { return pair[0]; });
    parse(currentSearch).forEach(function (pair) {
      var context = /^(utm_|gclid$|fbclid$|msclkid$|preview_theme_id$|_fd$|pb$|wo_availability$)/.test(pair[0]);
      var filter = preserveFilters && (pair[0] === 'sort_by' || pair[0].indexOf('filter.') === 0);
      if ((context || filter) && names.indexOf(pair[0]) === -1) { target.push(pair); }
    });
    var result = query(target);
    return result ? '?' + result : '';
  }
  function priceError(min, max) {
    if (min !== '' && (!isFinite(Number(min)) || Number(min) < 0)) { return 'Enter a minimum price of zero or more.'; }
    if (max !== '' && (!isFinite(Number(max)) || Number(max) < 0)) { return 'Enter a maximum price of zero or more.'; }
    if (min !== '' && max !== '' && Number(min) > Number(max)) { return 'Maximum price must be at least the minimum price.'; }
    return '';
  }
  function catalogLayout(root) {
    for (var i = 0; i < root.children.length; i++) {
      if (root.children[i].classList.contains('wo-catalog-layout')) { return root.children[i]; }
    }
    return null;
  }
  function refreshDefaultAvailability(root, destination) {
    var startingUrl = window.location.href;
    var target = new window.URL(destination + window.location.hash, startingUrl);
    var layout = catalogLayout(root);
    if (!layout || !window.fetch || !window.DOMParser || !window.AbortController || !window.history.replaceState) {
      window.location.replace(target.href);
      return;
    }
    var controller = new window.AbortController();
    var completed = false;
    var previousBusy = layout.getAttribute('aria-busy');
    var notice = document.createElement('p');
    notice.className = 'wo-results-count';
    notice.style.gridColumn = '1 / -1';
    notice.setAttribute('role', 'status');
    notice.textContent = 'Loading available products…';
    layout.insertBefore(notice, layout.firstChild);
    layout.setAttribute('aria-busy', 'true');
    root.setAttribute('data-wo-availability-loading', 'true');
    function unchanged() { return root.isConnected && layout.parentNode === root && window.location.href === startingUrl; }
    function finish() {
      if (completed) { return; }
      completed = true;
      window.clearTimeout(timer);
      window.removeEventListener('pagehide', cancel);
      window.removeEventListener('popstate', changed);
      window.removeEventListener('hashchange', changed);
      root.removeAttribute('data-wo-availability-loading');
      if (previousBusy === null) { layout.removeAttribute('aria-busy'); }
      else { layout.setAttribute('aria-busy', previousBusy); }
      if (notice.parentNode) { notice.parentNode.removeChild(notice); }
    }
    function cancel() { finish(); controller.abort(); }
    function changed() { if (!unchanged()) { cancel(); } }
    function fallback() {
      if (completed) { return; }
      var navigate = unchanged();
      cancel();
      if (navigate) { window.location.replace(target.href); }
    }
    var timer = window.setTimeout(fallback, 8000);
    window.addEventListener('pagehide', cancel);
    window.addEventListener('popstate', changed);
    window.addEventListener('hashchange', changed);
    // Fetch full server-rendered HTML, but never insert its page scripts or replace the live picker.
    window.fetch(target.href, { credentials: 'same-origin', redirect: 'error', signal: controller.signal,
      headers: { Accept: 'text/html' } }).then(function (response) {
      if (!response.ok) { throw new Error('Collection unavailable'); }
      var responseUrl = new window.URL(response.url || target.href, target.href);
      if (responseUrl.origin !== target.origin || responseUrl.pathname !== target.pathname ||
          responseUrl.searchParams.get('filter.v.availability') !== '1') { throw new Error('Unexpected collection response'); }
      return response.text();
    }).then(function (html) {
      if (completed) { return; }
      if (!unchanged()) { cancel(); return; }
      var parsed = new window.DOMParser().parseFromString(html, 'text/html');
      var incomingRoot = parsed.querySelector('[data-wo-collection]');
      var incoming = incomingRoot && catalogLayout(incomingRoot);
      if (!incoming || !incoming.querySelector('.wo-catalog-results')) { throw new Error('Missing collection results'); }
      // Even inline event attributes must not execute when the parsed fragment becomes live.
      Array.prototype.forEach.call(incoming.querySelectorAll('script, iframe, object, embed, base, meta, link'), function (node) { node.remove(); });
      Array.prototype.forEach.call([incoming].concat(Array.prototype.slice.call(incoming.querySelectorAll('*'))), function (node) {
        Array.prototype.slice.call(node.attributes).forEach(function (attribute) {
          if (/^on/i.test(attribute.name) || (/^(href|src|action|formaction|xlink:href)$/i.test(attribute.name) && /^\s*javascript:/i.test(attribute.value))) {
            node.removeAttribute(attribute.name);
          }
        });
      });
      var replacement = document.importNode(incoming, true);
      // Commit the URL first, so section-load listeners cannot start another default transition.
      window.history.replaceState(window.history.state, '', target.href);
      layout.parentNode.replaceChild(replacement, layout);
      finish();
      init(root);
      try {
        if (window.WheelsOutletCardSwatches && window.WheelsOutletCardSwatches.init) {
          Array.prototype.forEach.call(replacement.querySelectorAll('.wo-product-card'), window.WheelsOutletCardSwatches.init);
        }
      } catch (error) { /* Native product links and images still work if an optional enhancement fails. */ }
      try {
        if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.checkElems) { window.lazySizes.loader.checkElems(); }
        if (window.lazySizes && window.lazySizes.autoSizer && window.lazySizes.autoSizer.checkElems) { window.lazySizes.autoSizer.checkElems(); }
      } catch (error) { /* Current collection cards also use native lazy image loading. */ }
      replacement.dispatchEvent(new window.CustomEvent('shopify:section:load', { bubbles: true, detail: { woCatalogRefresh: true } }));
    }).catch(fallback);
  }
  function init(root) {
    if (root.getAttribute('data-wo-enhanced') === 'true' || root.getAttribute('data-wo-availability-loading') === 'true' || !window.URL || !window.FormData) { return; }
    var defaultAvailable = root.getAttribute('data-wo-default-availability') === 'true';
    var destination = defaultDestination(window.location.pathname, window.location.search, defaultAvailable);
    if (destination && !(window.Shopify && window.Shopify.designMode)) {
      refreshDefaultAvailability(root, destination);
      return;
    }
    var panel = root.querySelector('[data-wo-filter-panel]');
    if (panel && window.matchMedia) {
      var mobileFilters = window.matchMedia('(max-width: 699px)');
      var filterGroups = panel.querySelectorAll('[data-wo-filter-group]');
      function updateFilterLayout() {
        if (!root.isConnected) { return; }
        panel.open = true;
        for (var g = 0; g < filterGroups.length; g++) {
          filterGroups[g].open = !mobileFilters.matches || filterGroups[g].getAttribute('data-wo-filter-group') === 'diameter';
        }
      }
      updateFilterLayout();
      mobileFilters.addEventListener('change', updateFilterLayout);
    }

    var links = root.querySelectorAll('[data-wo-filter-link], [data-wo-tag-chip] a, .wo-pagination a');
    for (var i = 0; i < links.length; i++) {
      var target = new window.URL(links[i].href, window.location.href);
      if (target.origin !== window.location.origin) { continue; }
      target.search = contextSearch(target.search, window.location.search, !!links[i].closest('[data-wo-tag-chip]'));
      if (defaultAvailable && (links[i].hasAttribute('data-wo-clear-all') || links[i].hasAttribute('data-wo-clear-availability'))) {
        target.search = '?' + query(availabilityIntent(parse(target.search)));
      }
      links[i].href = target.href;
    }

    var forms = root.querySelectorAll('[data-wo-filter-form], [data-wo-sort-form]');
    for (var f = 0; f < forms.length; f++) {
      (function (form) {
        var ranges = form.querySelectorAll('[data-wo-price-range]');
        function validatePrices() {
          var valid = true;
          for (var p = 0; p < ranges.length; p++) {
            var min = ranges[p].querySelector('[data-wo-price-min]');
            var max = ranges[p].querySelector('[data-wo-price-max]');
            var error = priceError(min.value, max.value);
            min.setCustomValidity('');
            max.setCustomValidity(error);
            if (error) { valid = false; }
          }
          return valid;
        }
        form.addEventListener('input', validatePrices);
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          if (!validatePrices() || !form.checkValidity()) { form.reportValidity(); return; }
          var names = Array.prototype.map.call(form.elements, function (element) { return element.name; }).filter(Boolean);
          var entries = [];
          new window.FormData(form).forEach(function (value, key) { entries.push([key, value]); });
          var action = new window.URL(form.action, window.location.href);
          window.location.assign(formDestination(action.pathname, window.location.search, names, entries, defaultAvailable));
        });
        if (form.hasAttribute('data-wo-sort-form')) {
          var select = form.querySelector('[name="sort_by"]');
          select.addEventListener('change', function () {
            if (form.requestSubmit) { form.requestSubmit(); }
            else { form.dispatchEvent(new window.Event('submit', { bubbles: true, cancelable: true })); }
          });
        }
      })(forms[f]);
    }
    root.setAttribute('data-wo-enhanced', 'true');
  }
  window.WheelsOutletCollection = {
    parse: parse, query: query, formDestination: formDestination,
    contextSearch: contextSearch, priceError: priceError, init: init,
    defaultDestination: defaultDestination, availabilityIntent: availabilityIntent
  };
  function boot() {
    var roots = document.querySelectorAll('[data-wo-collection]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})(window, document);
